import { z } from "zod";

import {
	GoogleFreeBookingLinksAddressInputSchema,
	GoogleFreeBookingLinksSettingsI18nInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import { postalCodeZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

import type { ZodError } from "zod";

export const googleFreeBookingLinksSettingsI18nInputZodSchema = GoogleFreeBookingLinksSettingsI18nInputSchema.extend({
	hotelName: z.string().min(1),
	address: GoogleFreeBookingLinksAddressInputSchema.extend({
		postalCode: postalCodeZodSchema,
		province: z.string().min(1),
		city: z.string().min(1),
	}),
});

export type GoogleFreeBookingLinksSettingsI18nZodSchemaType = z.infer<
	typeof googleFreeBookingLinksSettingsI18nInputZodSchema
>;

export type GoogleFreeBookingLinksSettingsI18nZodParseErrorType =
	ZodError<GoogleFreeBookingLinksSettingsI18nZodSchemaType>;
